.accessModalFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--base-unit-l) 0 0 0;
}
